import { useEffect, useRef, useState } from 'react';
import { useEditorAsyncPropsContext } from '../../../../../../components/EditorAsyncProps';

export const useEditorAsyncProps = (componentName) => {
    const hasInjected = useRef(false);
    const { isEditMode = false, componentsAsyncProps = {} } = useEditorAsyncPropsContext();
    const [editorAsyncProps, setEditorAsyncProps] = useState({});

    useEffect(() => {
        if (!isEditMode || hasInjected.current) {
            return;
        }

        const asyncProps = componentsAsyncProps[componentName] || [];
        hasInjected.current = true;

        return setEditorAsyncProps(asyncProps.shift?.() || {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return editorAsyncProps;
};
